exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".normal-level{background:#f2fdff}.ideal-level{background:#f7ffed}.inventory-low .quantity,.low-level{background:#ffecec}.inventory-ideal .quantity{background:#f7ffed}.inventory-normal .quantity{background:#f2fdff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc8888ca","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/stock/stock-inventory-list.vue
// module id = nlF7
// module chunks = 1